import React, { useEffect, useState } from "react";
import "./SearchPage.css";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useCart } from "../Context/CartContext";
import { FaArrowLeft } from "react-icons/fa6";

import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

export default function SearchPage() {
  const navigate = useNavigate();
  const { keyword } = useParams();
  const { addToCart } = useCart();

  const [products, setProducts] = useState([]);

  /* FETCH PRODUCTS FROM FIREBASE */
  useEffect(() => {
    const fetchProducts = async () => {
      const querySnapshot = await getDocs(collection(db, "products"));

      const productArray = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setProducts(productArray);
    };

    fetchProducts();
  }, []);

  /* SEARCH FILTER */
  const filteredProducts = products.filter((product) =>
    product.name?.toLowerCase().includes(keyword.toLowerCase())
  );

  return (
    <section className="search-page">
      <div className="search-data">

        <div className="category-backarrow">
          <FaArrowLeft
            onClick={() => navigate("/")}
          />
        </div>

        <h2>
          Search Results for "{keyword}" ({filteredProducts.length} items)
        </h2>

      </div>

      <article className="search-products-display">

        {filteredProducts.length === 0 ? (
          <p>No products found</p>
        ) : (
          filteredProducts.map((v) => {

            const image =
              v.images && v.images.length > 0
                ? v.images[0]
                : "";

            return (
              <div className="search-product-data" key={v.id}>

                <Link to={`/product/${v.id}`}>

                  <div className="search-product-image">
                    <img src={image} alt={v.name} />
                  </div>

                  <div className="search-product-name">
                    {v.name}
                  </div>

                  <div className="search-product-price">
                    ₹{v.price}
                    <span className="oldprice">
                      ₹{v.oldprice}
                    </span>
                  </div>

                </Link>

                <div className="search-addtocart">
                  <button onClick={() => addToCart({ ...v, qty: 1 })}>
                    Add to cart
                  </button>
                </div>

              </div>
            );
          })
        )}

      </article>
    </section>
  );
}